import {IPresenter} from "@/rawdogjs/src/interfaces/IPresenter";
import {TopBarView} from "./topBarView";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";
import {Router} from "@/rawdogjs/src/router";
import {UserStore} from "../../data/stores/UserStore";

export class TopBarPresenter implements IPresenter {

    public _view: TopBarView;
    private _dependencyContainer: ParcelDependencyContainer;
    private _router: Router;
    private _userStore: UserStore;

    constructor(
        view: TopBarView,
        router: Router,
        dependencyContainer: ParcelDependencyContainer
    ) {
        this._view = view;
        this._dependencyContainer = dependencyContainer;
        this._router = router;
    }

    async initialize() {
        this._userStore = this._dependencyContainer.resolve<UserStore>('UserStore');
        const env = this._dependencyContainer.resolve<any>('env');
        
        this._view.appTitle = env.APP_TITLE;
        
        await this.setForm();

        this._userStore.targetTenantId$.subscribe(async (displayName) => {
            await this.setForm();
        })

        this._view.bind(this, async () => {
        });
    }

    async goToMenu() {
        this._router.navigate('/#/home');
    }

    async setForm() {
        const user = this._userStore.getTenantId()

        if (user) {
            this._view.showLoggedIn(true);
            this._view.displayName = this._userStore.getDisplayName();
            this._view.handle = `${this._userStore.getEmail()}`;
        } else {
            this._view.showLoggedIn(false);
        }
    }

    inject() {
    }

}

